import * as React from 'react'
import * as ReactDOM from 'react-dom'

interface Props { imageUrls: string[] }

export default function LightboxComponent ({ imageUrls }: Props) {
  const [openedIndex, setOpenedIndex] = React.useState<number>(null)

  const containerStyle: React.CSSProperties = {
    position: 'fixed',
    height: '100%',
    width: '100%',
    backgroundColor: 'rgba(0,0,0,.8)',
    top: 0,
    left: 0,
    zIndex: 100001
  }

  const imageStyle: React.CSSProperties = {
    position: 'fixed',
    margin: 0,
    padding: 0,
    maxHeight: '90%',
    maxWidth: '90%',
    top: '50%',
    left: '50%',
    marginRight: '-50%',
    transform: 'translate(-50%,-50%)',
    boxShadow: '0 0 20px #000',
    borderRadius: 3
  }

  return <div>
    { imageUrls.map((url, index) => <a key={ index } onClick={ () => setOpenedIndex(index) } style={{ cursor: 'pointer' }}>
      <img src={ url } style={{ width: '100%' }} />
    </a>) }

    { openedIndex !== null && ReactDOM.createPortal(
      <div style={ containerStyle } onClick={ () => setOpenedIndex(null) }>
        <img src={ imageUrls[openedIndex] } style={ imageStyle } />
      </div>,
        window.document.body
    ) }
  </div>
}
